"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.buildTransaction = void 0;
var invariant_1 = __importDefault(require("invariant"));
var bignumber_js_1 = require("bignumber.js");
var stellar_sdk_1 = __importDefault(require("stellar-sdk"));
var errors_1 = require("@ledgerhq/errors");
var api_1 = require("./api");
var logic_1 = require("./logic");
/**
 * @param {Account} a
 * @param {Transaction} t
 */
var buildTransaction = function (account, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var recipient, useAllAmount, networkInfo, fees, memoType, memoValue, amount, source, transactionBuilder, operation, recipientExists, memo, built;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                recipient = transaction.recipient, useAllAmount = transaction.useAllAmount, networkInfo = transaction.networkInfo, fees = transaction.fees, memoType = transaction.memoType, memoValue = transaction.memoValue;
                if (!fees) {
                    throw new errors_1.FeeNotLoaded();
                }
                (0, invariant_1["default"])(networkInfo && networkInfo.family === "stellar", "stellar family");
                amount = new bignumber_js_1.BigNumber(0);
                amount =
                    useAllAmount && networkInfo
                        ? account.balance.minus(networkInfo.baseReserve).minus(fees)
                        : transaction.amount;
                if (!amount)
                    throw new errors_1.AmountRequired();
                return [4 /*yield*/, (0, api_1.loadAccount)(account.freshAddress)];
            case 1:
                source = _a.sent();
                if (!source)
                    throw new errors_1.NetworkDown();
                transactionBuilder = (0, api_1.buildTransactionBuilder)(source, fees);
                operation = null;
                return [4 /*yield*/, (0, logic_1.addressExists)(transaction.recipient)];
            case 2:
                recipientExists = _a.sent();
                if (recipientExists) {
                    operation = (0, api_1.buildPaymentOperation)(recipient, amount);
                }
                else {
                    operation = (0, api_1.buildCreateAccountOperation)(recipient, amount);
                }
                transactionBuilder.addOperation(operation);
                memo = null;
                if (memoType && memoValue) {
                    switch (memoType) {
                        case "MEMO_TEXT":
                            memo = stellar_sdk_1["default"].Memo.text(memoValue);
                            break;
                        case "MEMO_ID":
                            memo = stellar_sdk_1["default"].Memo.id(memoValue);
                            break;
                        case "MEMO_HASH":
                            memo = stellar_sdk_1["default"].Memo.hash(memoValue);
                            break;
                        case "MEMO_RETURN":
                            memo = stellar_sdk_1["default"].Memo["return"](memoValue);
                            break;
                    }
                }
                if (memo) {
                    transactionBuilder.addMemo(memo);
                }
                built = transactionBuilder.setTimeout(0).build();
                return [2 /*return*/, built];
        }
    });
}); };
exports.buildTransaction = buildTransaction;
exports["default"] = exports.buildTransaction;
//# sourceMappingURL=js-buildTransaction.js.map